import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { RootState } from 'data/root.reducers'
import { useSelector, useDispatch } from 'react-redux';
import { SelectionChangedEvent } from '@ag-grid-community/core';
import { FqdnState, FqdnPrivileges } from 'data/fqdn/fqdn.types';
import {
 getFqdn, deleteAllByFsId, onSelectFqdn, onEnterFqdnlist as actionEnterFqdnList
} from 'data/fqdn/fqdn.actions'
import { SYSTEM_CONFIGURATION_ROUTE, NETWORK, FQDN } from '../../../constants';

export default () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const deliveryFunction = useSelector((state: RootState) => state.global.selectedDF);
    const privilegesList = useSelector<RootState, string[]>(({ authentication }) => authentication.privileges);
    const {
        items, isLoading, lastUpdatedAt, selectedItem
    } = useSelector<RootState, FqdnState>(({ fqdn }) => fqdn);

    const privileges = useMemo(() => ({
        view: privilegesList.includes(FqdnPrivileges.View),
        create: privilegesList.includes(FqdnPrivileges.Create),
        update: privilegesList.includes(FqdnPrivileges.Update),
        delete: privilegesList.includes(FqdnPrivileges.Delete)
    }), [privilegesList])

    const onRefresh = () => dispatch(getFqdn(deliveryFunction))

    const onDelete = () => {
        dispatch(deleteAllByFsId(deliveryFunction, items.filter(({ fsId }) => fsId === selectedItem?.fsId)))
    }

    const goToCreateFqdnPage = () => {
        history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}/create`)
    }

    const goToListFqdnPage = () => {
        history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}`)
    }

    const goToViewSelectedFqdnPage = () => {
        if (selectedItem){
            history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}/view`)
        }
    }

    const goToEditSelectedFqdnPage = () => {
        if (selectedItem){
            history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}/edit`)
        }
    }

    const getSelectedDomain = (event: SelectionChangedEvent) => {
        const nodes = event.api.getSelectedNodes();
        if (nodes.length){
            return nodes[0].data ? nodes[0].data : items.find(({ fsId: groupName }) => groupName === nodes[0].key)
        }
    }

    const onSelectionChanged = (event: SelectionChangedEvent) => dispatch(onSelectFqdn(getSelectedDomain(event)))

    const onEnterFqdnlist = () => {
        dispatch(actionEnterFqdnList())
        dispatch(getFqdn(deliveryFunction))
    }

    return {
        items,
        isLoading,
        privileges,
        selectedItem,
        lastUpdatedAt,
        onDelete,
        onRefresh,
        onEnterFqdnlist,
        goToListFqdnPage,
        goToCreateFqdnPage,
        onSelectionChanged,
        goToViewSelectedFqdnPage,
        goToEditSelectedFqdnPage
    };
}
